"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeaderTitle = HeaderTitle;
exports.HeaderSubtitle = HeaderSubtitle;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactI18next = require("react-i18next");

var _classnames = _interopRequireDefault(require("classnames"));

var _isString = _interopRequireDefault(require("lodash/isString"));

function WrapImgHasLink(_ref) {
  var hasLink = _ref.hasLink,
      children = _ref.children;

  if (!hasLink) {
    return children;
  }

  return /*#__PURE__*/_react["default"].createElement("a", {
    target: "_blank",
    rel: "noopener noreferrer",
    className: "cursor-pointer",
    href: "https://www.onmail.com"
  }, children);
}

var HeroHeader = function HeroHeader(_ref2) {
  var title = _ref2.title,
      subtitle = _ref2.subtitle,
      className = _ref2.className,
      children = _ref2.children,
      hasLink = _ref2.hasLink;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  return /*#__PURE__*/_react["default"].createElement("header", {
    className: (0, _classnames["default"])('flex-grow flex flex-col max-w-lg w-2/3', className)
  }, /*#__PURE__*/_react["default"].createElement(WrapImgHasLink, {
    hasLink: hasLink
  }, /*#__PURE__*/_react["default"].createElement("img", {
    width: "500",
    height: "134",
    className: (0, _classnames["default"])('w-2/5 h-auto mt-10'),
    src: t('onboard-logo'),
    alt: "OnMail"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col justify-center h-full flex-1"
  }, title && (0, _isString["default"])(title) ? /*#__PURE__*/_react["default"].createElement(HeaderTitle, null, title) : title, subtitle && (0, _isString["default"])(subtitle) ? /*#__PURE__*/_react["default"].createElement(HeaderSubtitle, null, subtitle) : subtitle, children));
};

function HeaderTitle(_ref3) {
  var className = _ref3.className,
      children = _ref3.children;
  return /*#__PURE__*/_react["default"].createElement("h1", {
    className: (0, _classnames["default"])('text-white font-bold text-3xl lg:text-4xl leading-tight', className)
  }, children);
}

function HeaderSubtitle(_ref4) {
  var className = _ref4.className,
      children = _ref4.children;
  return /*#__PURE__*/_react["default"].createElement("p", {
    className: (0, _classnames["default"])('text-white text-sm opacity-50', className)
  }, children);
}

var _default = HeroHeader;
exports["default"] = _default;
//# sourceMappingURL=index.js.map